// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"lesson-student-wrapper_mainContainer__oRvwA","wrapper":"lesson-student-wrapper_wrapper__2kDvj"};